import { render, staticRenderFns } from "./Page_Brand.vue?vue&type=template&id=3a7daff2&scoped=true&"
import script from "./Page_Brand.vue?vue&type=script&lang=js&"
export * from "./Page_Brand.vue?vue&type=script&lang=js&"
import style0 from "./Page_Brand.vue?vue&type=style&index=0&id=3a7daff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7daff2",
  null
  
)

export default component.exports